<template>
    <v-container>
        <v-row class="white-card">
            <v-col cols="12" class="title-section">
                {{ $t('routines.assign_to_calendar') }}
            </v-col>
            <v-col cols="12">
                <assign-routine-selector @success="toRoutines" :routine="routine" @valid="valid = $event"
                                         @loading="loading = $event" ref="assignRoutine"/>
            </v-col>
            <v-col cols="6">
                <v-btn class="cancel-btn" @click="toRoutines">
                    {{ $t('common.to_routines') }}
                </v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-btn class="next-btn" @click="assign" :loading="loading" :disabled="!valid">
                    {{ $t('common.assign') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import {db, Timestamp} from "@/utils/Firebase";
import AssignRoutineSelector from "@/components/coach/routines/AssignRoutineSelector";
import {clearBlocksAssignedRoutine} from "@/utils/Exercises";

export default {
    components: {
        AssignRoutineSelector,
    },
    data() {
        return {
            routine: null,
            loading: false,
            valid: false,
        }
    },
    computed: {
        routineId(vm = this) {
            return vm.$route.params.uid || null
        },
    },
    async mounted() {
        const vm = this
        await vm.loadRoutine()
    },
    methods: {
        toRoutines() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.routines`})
        },
        async loadRoutine() {
            let vm = this
            let routineRef = await db.collection('routines').doc(vm.routineId).get()
            vm.routine = {...routineRef.data(), id: routineRef.id}
        },
        async assign() {
            const vm = this
            vm.$refs.assignRoutine.checkAssignedRoutines()
        },
    }
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
    text-align: center;
}

.cancel-btn {
    border: 1px solid #F9F9F9;
    border-radius: 8px;
    color: #797979;
    text-transform: none;
    box-shadow: none;
    background: transparent !important;
}

.next-btn {
    border: 1px solid #F9F9F9;
    border-radius: 8px;
    color: #000000;
    text-transform: none;
    box-shadow: none;
    background: #CCFF99 !important;
}

</style>